var MediaTemplateEnum = /* @__PURE__ */ ((MediaTemplateEnum2) => {
  MediaTemplateEnum2["Original"] = "original";
  MediaTemplateEnum2["Resize"] = "resize";
  MediaTemplateEnum2["Crop"] = "crop";
  return MediaTemplateEnum2;
})(MediaTemplateEnum || {});
var MediaFormatEnum = /* @__PURE__ */ ((MediaFormatEnum2) => {
  MediaFormatEnum2["JPEG"] = "jpeg";
  MediaFormatEnum2["PNG"] = "png";
  MediaFormatEnum2["GIF"] = "gif";
  MediaFormatEnum2["TIFF"] = "tiff";
  MediaFormatEnum2["BMP"] = "bmp";
  MediaFormatEnum2["WEBP"] = "webp";
  return MediaFormatEnum2;
})(MediaFormatEnum || {});
export {
  MediaFormatEnum,
  MediaTemplateEnum
};
